import config from "../../config";
import { PaginationParams } from "./PaginationParams";

const getDefautPagination = (): PaginationParams => ({ page: 1, perPage: config.pagination.perPage });

export {
    getDefautPagination,
}
